import { Component } from "react";

// Keeps a crashing section from blanking the whole site.
export class SectionBoundary extends Component {
  state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  componentDidCatch(error) { console.error(`[section:${this.props.name}]`, error); }
  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <section data-testid={`section-error-${this.props.name}`} className="py-10">
        <div className="max-w-[1320px] mx-auto px-5 md:px-10">
          <div className="card p-6 text-sm muted">Dieser Bereich konnte gerade nicht geladen werden. Schreib uns einfach über das Formular – wir helfen dir persönlich weiter.</div>
        </div>
      </section>
    );
  }
}
